import * as React from 'react';

import {StatusBadge} from 'shells/status-badge/status-badge';

import styles from './analytics-status.module.css';

type Props = {
    numActiveForms: number;
    numDraftForms: number;
};

export function SubmissionsFrom(props: Props) {
    return (
        <>
            <div className={styles.text}>
                We’ve received submissions from{' '}
                <strong>
                    {props.numActiveForms + props.numDraftForms} connected form
                    {props.numActiveForms + props.numDraftForms === 1 ? '' : 's'}
                </strong>
                :
            </div>
            <div className='flex'>
                <div className={styles['form-info']}>
                    {props.numActiveForms} <StatusBadge level='success' text='Active' />
                </div>
                <div className={styles['form-info']}>
                    {props.numDraftForms} <StatusBadge level='info' text='Draft' />
                </div>
            </div>
        </>
    );
}
